import Vue from "vue";
import i18n from "@/plugins/i18n";
import VueI18n from "vue-i18n";

Vue.filter("formatDate", (value: string) => {
  if (value) {
    return new Date(value).toLocaleString(i18n.locale);
  }
});

Vue.filter("formatShortDate", (value: string) => {
  if (value) {
    const options: any = {year: "numeric", month: "numeric", day: "numeric"};
    return new Date(value).toLocaleString(i18n.locale, options);
  }
});

Vue.filter("formatAnniversaryDate", (value: string) => {
  if (value) {
    const options: any = {year: "numeric", month: "long", day: "numeric"};
    return new Date(value).toLocaleString(i18n.locale, options);
  }
});

Vue.filter("formatDateHour", (value: string) => {
  if (value) {
    const options: any = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
    };
    return new Date(value).toLocaleString(i18n.locale, options);
  }
});

Vue.filter("formatDateHourGmt", (value: string) => {

  if (value) {
  const options: any = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "numeric",
  minute: "2-digit",
  };
  const test = new Date(value).toLocaleString(i18n.locale, options);
  const test2 = new Date(value).toString().split("GMT");
  return test + " GMT" + test2[1].split("00")[0];
  }
});

Vue.filter("formatExecutionTime", (value: number): string => {
  // if (value < 1) {
  //   return `< 1 (s)`;
  // }
  return `${Math.ceil(value * 10) / 10} (s)`;
});

Vue.filter("formatConnectedBoxName", (connectedBox: any, format: string = "classic") => {
  if (connectedBox) {
    const boxName: string = connectedBox?.name ? ` ${connectedBox.name}` : "";
    return i18n.t(`connectedBox.providers.${format}.${connectedBox.provider}`) + boxName;

  }
});

Vue.filter("formatSizeName", (size: any) => {
  if (size) {
    return size.code + (size.description ? ` (${size.description})` : "");
  }
});

Vue.filter("lowerCase", (value: string | VueI18n.TranslateResult) => {
  if (value) {
    return String(value).toLowerCase();
  }
});

Vue.filter("truncateText", (text, length = 20) => {
  if (!text) { return ""; }
  if (text.length > length) {
    return text.substring(0, length) + "...";
  }
  return text;
});
